import { Routes } from "@angular/router";
import { loadTranslationResolver } from "@kernel/translations/resolvers/load-translations.resolver";
import { TRANSLATION_PATHS } from "@shared/general/translation/constants/translation.constant";
import { AuthGuard } from "@shared/auth/guards/auth.guard";
import { COMMON_GUARD_OPTIONS } from "@shared/auth/constants/permissions.constant";
import { WebsiteOfferRoutePaths } from "@app/applications/quotation/domains/website-offers/website-offer-route-paths";
import { viewWebsiteResolverResolver } from "@app/applications/quotation/domains/website-offers/resolvers/view-website-offer.resolver";

export const websiteOfferRoutes: Routes = [
  {
    path: "",
    resolve: {
      translate: loadTranslationResolver([
        TRANSLATION_PATHS.WEBSITE_OFFER.WEBSITE_OFFER,
        TRANSLATION_PATHS.VEHICLE_INFO,
        TRANSLATION_PATHS.FUEL_TYPE,
        TRANSLATION_PATHS.FEATURES,
        TRANSLATION_PATHS.PRICE_LIST,
        TRANSLATION_PATHS.STOCK.STOCK,
      ]),
    },
    children: [
      {
        path: "",
        pathMatch: "full",
        loadComponent: () => import("./pages/list-website-offer/list-website-offer.component").then(c => c.ListWebsiteOfferComponent),
        canActivate: [AuthGuard],
        data: { authGuardOptions: COMMON_GUARD_OPTIONS.WEBSITE_OFFER.VIEW },
      },
      {
        path: WebsiteOfferRoutePaths.CREATE,
        loadComponent: () => import("./pages/create-website-offer/create-website-offer.component").then(c => c.CreateWebsiteOfferComponent),
        canActivate: [AuthGuard],
        resolve: {
          translate: loadTranslationResolver([TRANSLATION_PATHS.TECHNICAL_DATA]),
        },
        data: { authGuardOptions: COMMON_GUARD_OPTIONS.WEBSITE_OFFER.CREATE },
      },
      {
        path: WebsiteOfferRoutePaths.EDIT,
        resolve: {
          translate: loadTranslationResolver([TRANSLATION_PATHS.TECHNICAL_DATA]),
          websiteOffer: viewWebsiteResolverResolver,
        },
        loadComponent: () => import("./pages/update-website-offer/update-website-offer.component").then(c => c.UpdateWebsiteOfferComponent),
        canActivate: [AuthGuard],
        data: { authGuardOptions: COMMON_GUARD_OPTIONS.WEBSITE_OFFER.UPDATE },
      },
      {
        path: WebsiteOfferRoutePaths.VIEW,
        resolve: {
          translate: loadTranslationResolver([TRANSLATION_PATHS.TECHNICAL_DATA]),
          websiteOffer: viewWebsiteResolverResolver,
        },
        loadComponent: () => import("./pages/view-website-offer/view-website-offer.component").then(c => c.ViewWebsiteOfferComponent),
        canActivate: [AuthGuard],
        data: { authGuardOptions: COMMON_GUARD_OPTIONS.WEBSITE_OFFER.VIEW },
      },
    ],
  },
];
